import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class DepartamentosProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  get(idEmpresa?: string)
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'departamentos';

      if(idEmpresa)
      {
        url += '?idEmpresa=' + idEmpresa;
      }

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getPaginated(paginacao: ApiPaginate) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'departamentos?operacao=page&' + paginacao.geraAPIUrl();

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  addupdate(dadosJson:any): Promise<{Item: any, erro: string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'departamentos';
      me.http.post(url, requestData,{headers:me.header})
        .subscribe((result: any) => {
          
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }


  delete(id:any, params = {}): Promise<{Item: any, erro: string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'departamentos';
      
      me.http.delete(url,{headers:me.header, params: {
        idDepartamento: id,
        ...params
      }})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  

}
